import "../css/SeccionVideo.css";

export default function SeccionVideo() {
  return (
    <section className="page video-section">
      <div className="video-content">
        <div className="video-text">

          <h2>
            Conoce la historia de Francisco Correoso,
            <span> protagonista del Reto de Carmen</span>
          </h2>

          <p>
            Descubre de primera mano cómo está viviendo esta experiencia,
  los desafíos que está superando y el impacto que el Reto de Carmen
  está teniendo en su vida. Una conversación inspiradora que muestra
  su esfuerzo, su capacidad de superación y la importancia de apoyar
  esta causa mientras sigue afrontando este gran reto.
          </p>
        </div>

        <div className="video-player" id="video-entrevista">
          <div className="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/18z02m6PYZ0"
              title="Entrevista a Francisco Correoso"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}